import React, { useState } from "react";
import { createPortal } from "react-dom";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function EditCommentModal({ onClose, onSave, comment }) {
  const [text, setText] = useState(comment.text || "");
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!text.trim()) {
      setError("Comment cannot be empty.");
      return;
    }

    setError("");
    onSave({ text: text.trim() });
    onClose();
  };

  const handleClose = () => {
    setText("");
    setError("");
    onClose();
  };

  const modal = (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[60] p-4">
      <div className="bg-surface-elevated rounded-2xl shadow-2xl w-full max-w-md p-6 relative border border-border-light">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-text-muted hover:text-text-secondary transition"
        >
          <XMarkIcon className="w-6 h-6" />
        </button>

        <h2 className="text-2xl font-bold mb-6 text-text-primary border-b pb-3">
          Edit Comment
        </h2>

        <div className="mb-5">
          <label className="block text-sm font-medium mb-2 text-text-secondary">
            Comment
          </label>
          <textarea
            className={`w-full bg-surface-elevated border rounded-lg px-4 py-2 text-text-primary focus:outline-none focus:ring-2 transition resize-none ${
              error
                ? "border-destructive focus:ring-red-300"
                : "border-strong focus:ring-primary-300"
            }`}
            rows="4"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Edit your comment..."
          ></textarea>
          {error && <p className="text-destructive text-xs mt-1">{error}</p>}
        </div>

        <div className="flex justify-end gap-3 border-t pt-4">
          <button
            onClick={handleClose}
            className="px-5 py-2 bg-surface-sunken text-text-secondary rounded-lg hover:bg-surface-muted"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-5 py-2 bg-primary text-text-inverse rounded-lg hover:bg-primary"
          >
            Update Comment
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
